import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { res } from '../../../common/language/text/res';
import { Strings } from '../../../common/language/strings';
import { LoggerLayout } from '../../../common/model/LoggerLayout';
import { Permissions } from '../../../common/model/dictionary/Permissions'
import { LoggerLayoutsFacade } from '../../../common/facade/LoggerLayoutsFacade';

@Component({
  selector: 'app-logger-layouts',
  templateUrl: './logger-layouts.component.html',
  styleUrls: ['./logger-layouts.component.css']
})
export class LoggerLayoutsComponent implements OnInit {
  @ViewChild('createModal') public createModal: ModalDirective;

  titleLoggerLayouts = res.LoggerLayout
  lblCode = res.LayoutCode
  lblMessage = res.Message
  lblUser = res.Username
  lblType = res.IncidenceWithLayout
  lblDate = res.IncidenceDate
  lblView = res.View;
  lblClose = res.Close;
  lblSearch = res.Search;
  details: LoggerLayout[] = [];
  private _filteredData: LoggerLayout[];

  loading = false;
  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };
  messageLoader = '';

  visibleRead = false;

  alertModal: any[] = [];
  permissionsList: any[] = [];

  public logMessage: string = '';

  constructor(@Inject(SESSION_STORAGE) private _storage: WebStorageService,
    public strings: Strings,
    public _facadeLog: LoggerLayoutsFacade) { }

  ngOnInit(): void {
    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';
    this.messageLoader = this.strings.GetText(res.Loading);

    this.validatePermissions();
    this.LoadInformation();
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions')

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.LogLayoutRead) {
        this.visibleRead = true;
      }
    });
  }

  LoadInformation() {
    if (this.visibleRead) {
      this.loading = true;
      this._facadeLog.GetAllLogger().subscribe(result => {
        if (result.completed) {
          this.details = result.data;
          this._filteredData = result.data;
        }
        this.loading = false;
      },
        error => {
          this.loading = false;
          this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
        });
    }
    else{
      this.addAlertModal('<strong>No cuenta con los permisos de lectura, contacte al administrador.</strong>', 'warning');
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.details = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

  addAlertModal(message: String, type: String): void {
    this.alertModal.push({
      type: type,
      msg: message,
      timeout: 5000
    });
  }

  onClosed(dismissedAlert: AlertComponent) {
    this.alertModal = this.alertModal.filter(alert => alert !== dismissedAlert);
  }

  viewMessage(detail: string){
    this.logMessage = detail;
    this.createModal.show();
  }
}

